import store from 'vuex-store/index'
import router from '@/router'
import { showNotice } from '@/utils/tool'
import i18n from '@/i18n'
import Vue from 'vue'

export function login(data, redirectPath) {
  store.dispatch('SetUserData', data)
  store.dispatch('UpdateCsUrl')
  // socket重連
  Vue.prototype.$socket.reinit()

  if (redirectPath == null) {
    return
  }

  if (redirectPath.indexOf('match') > -1) {
    window.location.href = redirectPath
    return
  }

  if (data.member_info.password_valid === 0) {
    // 強制改密碼
    showNotice(i18n.t('Bao.reset_password_notice'))
    router.push({ path: '/user/reset' })
  } else {
    // 登入
    if (redirectPath === undefined) {
      redirectPath = 'index'
    }
    router.push({ path: '/' + redirectPath }).catch(() => {
    })
  }

  router.next()
}

export function logout(msg) {
  // 呼叫app
  try {
    window.webkit.messageHandlers.openLogin.postMessage(null)
    return
  } catch (e) {
    // console.error(e)
  }
  try {
    window.JSInterface.openLogin()
    return
  } catch (e) {
    // console.log(e)
  }

  router.push({ path: '/' }).catch(() => {
  })

  if (msg === undefined) {
    msg = i18n.t('Bao.has_logout')
  }
  store.dispatch('LogOut').then(() => {
    store.dispatch('UpdateCsUrl')
    try {
      // eslint-disable-next-line
      if (WebviewInterface !== undefined) {
        // eslint-disable-next-line
        WebviewInterface.logout()
      }
    } catch (e) {
      console.log('WebviewInterface', e)
    }
    // socket斷線
    Vue.prototype.$socket.close()
    showNotice(msg)
  })
}
